import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../../app/theme';
import { TWD } from '../../../app/utils';
import IconDelete from '../../../assets/images/Icons/IconDelete';
import Checkbox from '../../shared/Checkbox';
import Tooltip from '../../shared/Tooltip';

const useStyles = makeStyles(
  {
    List: {
      height: 50,
      padding: '0 16px',
      minHeight: 34,
      display: 'grid',
      gridTemplateColumns: 'auto 88px 40px',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '13px',
      color: color.$13,
      '& > div': {
        paddingRight: 8,
        display: 'flex',
        alignItems: 'center',
      },
    },
    delete: {
      cursor: 'pointer',
    },
    isSelected: {
      background: '#F0F6CC !important',
    },
    isHover: {
      background: color.$19,
    },
    data: {
      margin: '3px 0',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      wordBreak: 'break-all',
      '& > a': {
        color: color.$2,
        textDecorationLine: 'underline',
      },
    },
    red: {
      color: color.$17,
    },
    index: {
      width: 34,
      minWidth: 34,
      textAlign: 'center',
    },
  },
  {
    name: 'ImportDataRow',
  },
);

const ImportDataRow = ({
  index,
  dataType,
  isSelected,
  onSelectRow,
  data,
  onDelete,
  disabled,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={classnames(classes.List, {
        [classes.isSelected]: isSelected,
        [classes.isHover]: isHover,
      })}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div style={{ overflow: 'hidden', padding: '6px 8px 6px 0px' }}>
        {isHover || isSelected ? (
          <Checkbox
            checked={isSelected}
            onClick={() => onSelectRow(data?.id)}
            disabled={disabled}
          />
        ) : (
          <div className={classes.index}>{index + 1}</div>
        )}
        <Tooltip
          isComponent
          placement="top"
          title={
            <div style={{ lineHeight: 1.4 }}>
              {data?.name}
              {data?.name && <br />}
              {dataType === 'web' && data?.url}
            </div>
          }
        >
          <div style={{ width: '100%', display: 'grid' }}>
            {data?.name && <div className={classes.data}>{data?.name}</div>}
            {dataType === 'web' && (
              <div className={classes.data}>
                <a href={data?.url} rel="noopener noreferrer" target="_blank">
                  {data?.url}
                </a>
              </div>
            )}
          </div>
        </Tooltip>
      </div>
      {!data?.wordCount ? (
        <Tooltip
          isComponent
          placement="top"
          title={t(`${pathKey}:${data?.error}`) || ''}
        >
          <div className={classes.red}>
            {TWD(data?.wordCount, false).format()}
          </div>
        </Tooltip>
      ) : (
        <div>{TWD(data?.wordCount, false).format()}</div>
      )}
      <div>
        {!disabled && (
          <Tooltip placement="top" title={t(`${pathKey}:deleteDataset`)}>
            <div>
              <IconDelete
                className={classes.delete}
                id={`icon-delete-${0}`}
                width={20}
                height={20}
                color={color.$10}
                hoverColor={color.$10}
                onClick={onDelete}
              />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default ImportDataRow;
